import {RouteProps} from 'config/navigation';

import PaymentMethods from './payment-methods';
import CreatePaymentMethod from './create-payment-method';
import EditPaymentMethod from './edit-payment-method';
import {IoWallet} from 'react-icons/io5';

const paymentMethodsPages: RouteProps = {
  name: 'Formas de pagamento',
  path: 'payment-methods',
  permission: 'paymentMethods.findAll',
  icon: <IoWallet />,
  subRoutes: [
    {
      path: '',
      element: <PaymentMethods />,
      permissions: ['paymentMethods.findAll'],
    },
    {
      path: 'create',
      element: <CreatePaymentMethod />,
      permissions: ['paymentMethods.findOne'],
    },
    {
      path: ':id',
      element: <EditPaymentMethod />,
      permissions: ['paymentMethods.findOne'],
    },
  ],
};

export default paymentMethodsPages;
